import React, { useState, useContext, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import '../css/Login.css';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const { login, updateGroups } = useContext(AuthContext);

  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const isInAppBrowser = () => {
    const ua = navigator.userAgent || '';
    return /KAKAOTALK|NAVER|Instagram|FBAN|FBAV|Line|SamsungBrowser\/\d.*Mobile VR|wv\)/.test(ua);
  };

  const handleGoogleLogin = () => {
    if (isInAppBrowser()) {
      toast.warn(t('login.inAppBrowserWarning'), { autoClose: 8000 });
      return;
    }
    window.location.href = `${backendUrl}/api/v1/auth/oauth/google`;
  };

  // URL ?error= 파라미터 처리 (OAuth 실패 리다이렉트)
  useEffect(() => {
    const errorParam = searchParams.get('error');
    if (errorParam) {
      toast.error(t('login.oauthError'));
      // URL에서 error 파라미터 제거
      window.history.replaceState({}, document.title, '/login');
    }
  }, [searchParams, t]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await login(username, password);
      updateGroups(data.groups);
      navigate('/'); // 로그인 성공 시 홈으로 이동
    } catch (err) {
      setError(t('login.error'));
    }
  };

  return (
    <div className="login-container">
      <h2>{t('login.login')}</h2>
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div>
          <label>{t('login.username')}</label>
          <input
            type="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label>{t('login.password')}</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">{t('login.login')}</button>
        <p style={{ marginTop: '10px', textAlign: 'center' }}>
          {t('noAccount')} <span onClick={() => navigate('/register')} style={{ color: 'var(--link-color)', cursor: 'pointer', textDecoration: 'underline' }}>{t('register')}</span>
        </p>
      </form>

      <div className="social-login-divider">
        <span>{t('login.orContinueWith')}</span>
      </div>

      <div className="social-login-buttons">
        <button
          type="button"
          className="social-btn google-btn"
          onClick={handleGoogleLogin}
        >
          <img src="/images/google-icon.svg" alt="Google" className="social-icon" />
          {t('login.googleLogin')}
        </button>
      </div>
      <p style={{ marginTop: '16px', textAlign: 'center', fontSize: '12px', color: 'var(--text-muted)' }}>
        <a href="/privacy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-muted)', textDecoration: 'underline' }}>
          {t('privacy.viewPolicy')}
        </a>
      </p>
    </div>
  );
}

export default Login;
